import theme from 'config/theme';

export const STATUSES_COLORS = {
  Created: {
    backgroundColor: theme.palette.blues.primaryBlue100,
    color: theme.palette.blues.primaryBlue900,
  },
  Paid: {
    backgroundColor: theme.palette.greens.green200,
    color: theme.palette.greens.green900,
  },
  Completed: {
    backgroundColor: theme.palette.teals.teal200,
    color: theme.palette.teals.teal900,
  },
  Canceled: {
    backgroundColor: theme.palette.oranges.orange200,
    color: theme.palette.oranges.orange900,
  },
  Refunded: {
    backgroundColor: theme.palette.purples.purple200,
    color: theme.palette.purples.purple900,
  },
  Failed: {
    backgroundColor: theme.palette.reds.red200,
    color: theme.palette.reds.red900,
  },
};
